// @flow
import type { Action } from '../../actions/orgDashboard/search';

export type State = {
  orgId?: string,
  apiKey?: string,
  pageIndex: number,
  type: string,
  status: string,
  query: string,
  results: ?SearchResults,
  typeCounts: ?{ [string]: number },
  filters: { isFetching: boolean, status: Array<string> }
};

const initialState = {
  pageIndex: 0,
  type: 'ALL',
  status: 'ALL',
  query: '',
  results: null,
  typeCounts: null,
  filters: { status: [], isFetching: false }
};

export default function search(state: State = initialState, action: Action) {
  switch (action.type) {
    case 'ORG_DASHBOARD_SEARCH_START': {
      const { orgId, apiKey, listingType, status, query, pageIndex } = action;
      return Object.assign({}, state, {
        orgId,
        apiKey,
        pageIndex,
        type: listingType,
        status,
        query,
        results: state.results,
        typeCounts: orgId === state.orgId ? state.typeCounts : null
      });
    }

    case 'ORG_DASHBOARD_SEARCH_SUCCESS':
      return {
        ...state,
        results: action.results
      };
    case 'ORG_DASHBOARD_SET_TYPE_COUNTS':
      return {
        ...state,
        typeCounts: action.typeCounts
      };
    case 'ORG_DASHBOARD_FACETS_START': {
      return {
        ...state,
        filters: {
          ...state.filters,
          isFetching: true
        }
      };
    }
    case 'ORG_DASHBOARD_FACETS_SUCCESS': {
      const orgStatuses: Array<string> = Object.keys(
        action.facets.status || {}
      );
      return {
        ...state,
        filters: {
          status: orgStatuses,
          isFetching: false
        }
      };
    }

    default:
      // this causes a flow error if there are any unhandled actions
      (action: empty); // eslint-disable-line no-unused-expressions
      return state;
  }
}
